export enum ImageTypeEnum {
  URL = 'url',
  UPLOAD = 'upload',
}
